<div class="stop-counter-widget" [style.max-width]="maxWidth" #wrap>
  <div class="tabs">
    <button type="button" (click)="setProduct('prad')" [class.active]="product === 'prad'">Prąd</button>
    <button type="button" (click)="setProduct('gaz')" [class.active]="product === 'gaz'">Gaz</button>
    <button type="button" (click)="setProduct('fotowoltaika')" [class.active]="product === 'fotowoltaika'">Fotowoltaika</button>
  </div>
  <sc-initial-form 
      [type]="type"
      [small]="!!small"
      [zipCode]="zipCode" 
      [product]="product" 
      [buttonText]="buttonText"
      [linkFilterFn]="prepareExternalLinks"
      (onsubmit)="onSubmitForm($event)"
  ></sc-initial-form>
</div>